"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

var _InternalLink = _interopRequireDefault(require("../Navigation/InternalLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
const profileConfig = {
  standard: {
    color: _BaseTheme.default.colors.textgray,
    backgroundColor: '#EEF1F6',
    borderColor: _BaseTheme.default.colors.bluegray,
    textTransform: 'capitalize'
  },
  primary: {
    color: _BaseTheme.default.colors.textgray,
    backgroundColor: '#DFF1FF',
    borderColor: _BaseTheme.default.colors.blue,
    textTransform: 'capitalize'
  },
  warning: {
    color: _BaseTheme.default.colors.textgray,
    backgroundColor: 'rgba(254, 153, 0, 0.2)',
    borderColor: _BaseTheme.default.colors.orange,
    textTransform: 'capitalize'
  },
  success: {
    color: _BaseTheme.default.colors.textgray,
    backgroundColor: '#D7F6D5',
    borderColor: _BaseTheme.default.colors.green,
    textTransform: 'capitalize'
  },
  alert: {
    color: _BaseTheme.default.colors.textgray,
    backgroundColor: '#FEECEB',
    borderColor: _BaseTheme.default.colors.red,
    textTransform: 'capitalize'
  },
  title: {
    color: _BaseTheme.default.colors.gray,
    backgroundColor: '#EEF1F6',
    borderColor: '#EEF1F6',
    padding: '0.4rem 0.5rem',
    textTransform: 'uppercase'
  }
};

const BadgeWrapper = _styledComponents.default.div.withConfig({
  displayName: "Badge__BadgeWrapper",
  componentId: "design-system__sc-1gpa12r-0"
})(["display:inline-block;.badge-wrapper + &{margin-left:", "}& > div{background-color:", ";border-radius:", ";border:1px solid ", ";box-sizing:border-box;display:inline-block;min-width:2.5rem;padding:0;text-align:center;text-transform:", ";display:flex;& > span,& > a{font-family:", ";font-size:", ";color:", ";line-height:1.7;padding:0 ", ";}& button{align-items:center;display:flex;padding:0 ", " 0 ", ";box-sizing:border-box;border-radius:2px;border:none;background:none;cursor:pointer;transition:all 100ms;&:hover{background-color:rgba(255,255,255,0.5);}& svg{display:block;}}}"], _BaseTheme.default.distance.small, _ref => {
  let {
    profile
  } = _ref;
  return profileConfig[profile].backgroundColor;
}, _BaseTheme.default.radius.regular, _ref2 => {
  let {
    profile
  } = _ref2;
  return profileConfig[profile].borderColor;
}, _ref3 => {
  let {
    profile
  } = _ref3;
  return profileConfig[profile].textTransform || 'none';
}, _BaseTheme.default.type.family.content, _BaseTheme.default.type.size.small, _ref4 => {
  let {
    profile
  } = _ref4;
  return profileConfig[profile].color;
}, _BaseTheme.default.distance.small, _BaseTheme.default.distance.small, _BaseTheme.default.distance.small);

const Badge = _ref5 => {
  let {
    children,
    profile,
    onClick,
    to
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(BadgeWrapper, {
    className: "badge-wrapper",
    profile: profile
  }, /*#__PURE__*/_react.default.createElement("div", null, to ? /*#__PURE__*/_react.default.createElement(_InternalLink.default, {
    to: to
  }, children) : /*#__PURE__*/_react.default.createElement("span", {
    className: "label-wrapper"
  }, children), onClick && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "delete",
    size: "8"
  }))));
};

Badge.propTypes = {
  children: _propTypes.default.string.isRequired,
  profile: _propTypes.default.oneOf(['standard', 'primary', 'success', 'warning', 'alert', 'title']),
  onClick: _propTypes.default.func,
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.func])
};
Badge.defaultProps = {
  profile: 'standard',
  onClick: undefined,
  to: undefined
};
var _default = Badge;
exports.default = _default;